package navigation.root.auth

import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val authUiModule
    get() =
        module {
            factoryOf(::AuthScreenModel)
        }
